// extracted by mini-css-extract-plugin
export var currentStep = "_gc-2";
export var nodeCard = "_gc-0";
export var pathHighlighted = "_gc-1";